/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ({

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('app').config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/login', {
            templateUrl: 'assets/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
        });
    }]).controller('LoginController', loginController);

    loginController.$inject = ['$location', '$sessionStorage', 'authService'];

    function loginController($location, $sessionStorage, authService) {
        var vm = this;
        angular.extend(vm, {
            $sessionStorage: $sessionStorage,
            isLoading: true,
            isAnonymousLoginAllowed: false,
            loginDone: false,
            error: '',
            agencies: {},
            selectedAgency: '',
            loginFormSubmit: function loginFormSubmit() {
                vm.error = '';
                if (!vm.username || !vm.password) {
                    // no validation for anonymous user (as guest)
                    if (!vm.isAnonymousLoginAllowed) {
                        vm.error = 'Username or password must not be empty.';
                    }

                    return;
                }
                authService.login(vm.username, vm.password).then(function (resp) {
                    if (resp.d.authenticated) {
                        vm.loginDone = true;
                        vm.agencies = resp.d.agencies;
                        if (vm.agencies) vm.selectedAgency = vm.agencies[0];
                        if (vm.agencies && vm.agencies.length === 1) {
                            vm.agencyFormSubmit();
                        }
                    } else {
                        vm.error = resp.d.error;
                    }
                }).catch(function (e) {
                    var message = e;
                    if (e.data && (e.data.Message || e.status)) {
                        message = 'Server error: ' + (e.data.Message || e.status);
                    }

                    vm.error = 'Error: ' + message;
                });
            },
            agencyFormSubmit: function agencyFormSubmit() {
                if (!vm.selectedAgency) {
                    return;
                }

                // put agency in session scope
                $sessionStorage.logonInfo.agency = vm.selectedAgency;
                vm.password = '';
                var whereTo = $location.search().returnTo;
                $location.search('returnTo', null);
                $location.path(whereTo || "/");
            },
            cancelLogin: function cancelLogin() {
                authService.logout();
                vm.selectedAgency = '';
                vm.loginDone = false;
                vm.error = '';
                vm.username = '';
                vm.password = '';
            },
            loginAsGuest: function loginAsGuest() {
                vm.loginDone = true;
                authService.login(null, null).then(function (resp) {
                    if (resp.d.authenticated) {
                        vm.loginDone = true;
                        vm.agencies = resp.d.agencies;
                        if (vm.agencies) {
                            vm.selectedAgency = vm.agencies[0];
                            vm.agencyFormSubmit();
                        }
                    } else {
                        vm.error = resp.d.error;
                    }
                }).catch(function (e) {
                    var message = e;
                    if (e.data && (e.data.Message || e.status)) {
                        message = 'Server error: ' + (e.data.Message || e.status);
                    }

                    vm.error = 'Error: ' + message;
                });
            },
            loginUsingTicket: function loginUsingTicket(ticketId) {
                vm.loginDone = true;
                authService.loginUsingTicket(ticketId).then(function (resp) {
                    if (resp.d.authenticated) {
                        vm.loginDone = true;
                        vm.agencies = resp.d.agencies;
                        if (vm.agencies) {
                            vm.selectedAgency = vm.agencies[0];
                            vm.agencyFormSubmit();
                        }
                    } else {
                        vm.error = resp.d.error;
                    }
                }).catch(function (e) {
                    var message = e;
                    if (e.data && (e.data.Message || e.status)) {
                        message = 'Server error: ' + (e.data.Message || e.status);
                    }

                    vm.error = 'Error: ' + message;
                });
            },
            searchArgs: $location.absUrl().indexOf('?') !== -1 ? _.chain($location.absUrl().split('?').pop()).split('&').map(_.ary(_.partial(_.split, _, '='), 1)).fromPairs().value() : ''
        });

        if (!$sessionStorage.logonInfo) {
            authService.retrieveEnvironment().then(function () {
                vm.isLoading = false;
                vm.brandHeaderLink = $sessionStorage.environment.brandHeaderLink;
                // ticketId = '20a5bc0e-2dc2-4bc1-80e9-9ff9cd32f8c2';
                if (vm.searchArgs.ticketId) {
                    vm.loginUsingTicket(vm.searchArgs.ticketId);
                }
                // anonymous mode on server = no login needed
                else if ($sessionStorage.environment.isAnonymousLoginAllowed) {
                        vm.isAnonymousModeEnabled = true;
                        vm.loginAsGuest();
                    }
            }).catch(function (e) {
                vm.isLoading = false;
                var message = e;
                if (e.data && (e.data.Message || e.status)) {
                    message = 'Server error: ' + (e.data.Message || e.status);
                }

                vm.error = 'Error: ' + message;
            });
        } else {
            vm.isLoading = false;
            vm.isAnonymousLoginAllowed = $sessionStorage.environment.isAnonymousLoginAllowed;
        }
    }
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// loginController_f61149ed4534c2438558.js